import { GET_ALL_VENDOR_EARNINGS, GET_ALL_HISTORY_EARNINGS } from "../../types";

const initialState = {
  get_all_vendor_earnings: [],
  get_all_history_earnings: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_VENDOR_EARNINGS:
      return {
        ...state,
        get_all_vendor_earnings: payload,
      };
    case GET_ALL_HISTORY_EARNINGS:
      return {
        ...state,
        get_all_history_earnings: payload,
      };
    default:
      return state;
  }
}
